import { VcsMenuCategory, VcsMenuCategoryPermission } from "./enum";
import { Paths } from "./paths";

interface CategoryPermissionLinkModel {
	MenuCategoryPermissionId: VcsMenuCategoryPermission;
	Path: string;
	PriorityInSection: number;
}

export const routemapper: CategoryPermissionLinkModel[] = [
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.NewTextAnalysis,
		Path: Paths.TextAnalysis,
		PriorityInSection: 1
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.ReaderWriterAnalysis,
		Path: Paths.ReaderWriterTextAnalysis,
		PriorityInSection: 2
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.WordManager,
		Path: Paths.WordManager,
		PriorityInSection: 2
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.ObjectiveManager,
		Path: Paths.ObjectiveManager,
		PriorityInSection: 3
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.CommonEntities,
		Path: Paths.TeachingActivities,
		PriorityInSection: 4
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.Reports,
		Path: Paths.ScopeSequence,
		PriorityInSection: 5
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.WordCount,
		Path: Paths.TextWriterWordCount,
		PriorityInSection: 1
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.WordPhraseSearch,
		Path: Paths.WordPhraseSearch,
		PriorityInSection: 2
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.TextChangeAnalysis,
		Path: Paths.TextChangeAnalysis,
		PriorityInSection: 3
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.TagList,
		Path: Paths.LanguageFunctionTagList,
		PriorityInSection: 3
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.TagUsageStatistics,
		Path: Paths.TotalReport,
		PriorityInSection: 4
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.TagUsageDetails,
		Path: Paths.DetailsReport,
		PriorityInSection: 5
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.UnitList,
		Path: Paths.UnitList,
		PriorityInSection: 1
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.WordDetails,
		Path: Paths.VocabularyList,
		PriorityInSection: 2
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.Permissions,
		Path: Paths.PermissionManager,
		PriorityInSection: 1
	},
	{
		MenuCategoryPermissionId: VcsMenuCategoryPermission.ContentAdministrators,
		Path: Paths.ContentAdministrator,
		PriorityInSection: 2
	}
];

export const topLevelRouteMap = new Map<VcsMenuCategory, Paths>([
	[VcsMenuCategory.UserManagement, Paths.ContentAdministrator],
	[VcsMenuCategory.CurriculumManagement, Paths.Components],
	[VcsMenuCategory.LanguageFunctionManagement, Paths.LanguageFunctions],
	[VcsMenuCategory.ListManagement, Paths.DetailsReport],
	[VcsMenuCategory.TextAnalysis, Paths.TextAnalysis],
	[VcsMenuCategory.Vocabulary, Paths.TextGuardian]
]);
